import React, { createContext, useContext, useEffect, useState } from 'react';
import { ensureCatalogToken } from '../admin/jscontrol/apiClient';
import {
  fetchActiveAddBannersByOrder,
  getActiveBannersList,
} from '../utils/addBannerStorefront';

const AddBannerContext = createContext({
  bannersByOrder: {},
  activeBanners: [],
  loaded: false,
});

export function AddBannerProvider({ children, catalogReady = true }) {
  const [bannersByOrder, setBannersByOrder] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!catalogReady) return undefined;
    let cancelled = false;

    const load = async () => {
      ensureCatalogToken();
      try {
        const map = await fetchActiveAddBannersByOrder();
        if (!cancelled) {
          setBannersByOrder(map);
          setLoaded(true);
        }
      } catch {
        if (!cancelled) {
          setBannersByOrder({});
          setLoaded(true);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [catalogReady]);

  const activeBanners = getActiveBannersList(bannersByOrder);

  return (
    <AddBannerContext.Provider value={{ bannersByOrder, activeBanners, loaded }}>
      {children}
    </AddBannerContext.Provider>
  );
}

export function useAddBanner(displayOrder) {
  const { bannersByOrder } = useContext(AddBannerContext);
  return bannersByOrder[displayOrder] ?? null;
}

export function useActiveAddBanners() {
  const { activeBanners } = useContext(AddBannerContext);
  return activeBanners;
}

export default AddBannerContext;
